<script setup lang="ts">
import { AccordionContent } from '../accordion'
import { NavigationMenuContent } from '../navigation-menu'
import { useMediaQuery } from '../utils/use-media-query'

const isDesktop = useMediaQuery('md')
</script>

<template>
  <NavigationMenuContent v-if="isDesktop"
                         :side-offset="2">
    <slot />
  </NavigationMenuContent>
  <AccordionContent v-else
                    tw-class="group-data-[state=open]:bg-primary-50 py-2 flex flex-col gap-2 text-xs border-t">
    <slot />
  </AccordionContent>
</template>
